import { createSlice } from '@reduxjs/toolkit';
import { fetchCommunityDataWithPagination } from '../CommunityAPI/communityApi';

const fetchCommunityDataWithPaginationSlice = createSlice({
  name: 'fetchCommunityDataWithPagination',
  initialState: {
    data: [],
    loading: false,
    error: null,
    page: 1,
    pageSize: 10,
  },
  reducers: {
    setPage(state, action) {
      state.page = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommunityDataWithPagination.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityDataWithPagination.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCommunityDataWithPagination.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export const { setPage, setPageSize } = fetchCommunityDataWithPaginationSlice.actions;
export default fetchCommunityDataWithPaginationSlice.reducer;
